export default __webpack_public_path__ + "static/media/gif7.778080f4.gif";